import Box from 'components/shared/Box'
import styled from 'styled-components'
import { respondAbove } from 'styles/mediaQueries'

const ModalBody = styled(Box)`
    background: ${({ theme }) => theme.colors.grayscale_200};
    border-radius: 0 0 8px 8px;
`

export const SpaModalBody = styled(Box)`
    background: ${({ theme }) => theme.colors.grayscale_200};
    border-radius: 0 0 8px 8px;
`

export const TransportModalBody = styled(ModalBody)`
    @media ${respondAbove.xl} {
        > div:nth-child(2) {
            > div {
                width: fit-content;
            }
            > div:first-child {
                max-width: 170px;
            }
        }
    }
`

export const WellnessModalBody = styled(ModalBody)`
    > div:nth-child(1) {
        margin: 0;
    }
`

export const SymulatorModalBody = styled(ModalBody)`
    @media ${respondAbove.xl} {
        > div:nth-child(1) {
            > div {
                max-width: 50%;
            }
        }
    }
`

export const CabanaModalBody = styled(ModalBody)`
    @media ${respondAbove.xl} {
        > div:nth-child(1) {
            align-self: center;
            > div {
                max-width: 45%;
                &:first-child,
                &:nth-child(2) {
                    margin-bottom: 32px;
                }
            }
        }
    }
`
